import api from "../../../api";
import urls from "../../../urls";

export async function resetPassword(email: string) {
  await api.publicRequest("POST", urls.auth.resetPassword(), {
    email
  });
}
